"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var Item_1 = __importDefault(require("../Item/Item"));
var genIcon_1 = __importDefault(require("../../../utils/genIcon"));
/**
 * For something like an icon-based notification inside of the Header, the IconItem might be a better option than the standard Item.
 It is important to not that the required `description` prop will be converted to text once this item is added the collapsed dropdown menu. If `count`, which is a string is set to a empty string it will show just the icon.
 */
var IconItem = /** @class */ (function (_super) {
    __extends(IconItem, _super);
    function IconItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconItem.prototype.render = function () {
        var _a = this.props, badge = _a.badge, badgeColor = _a.badgeColor, iconColor = _a.iconColor, icon = _a.icon, iconRoot = _a.iconRoot, description = _a.description, itemProps = __rest(_a, ["badge", "badgeColor", "iconColor", "icon", "iconRoot", "description"]);
        return (React.createElement(Item_1.default, __assign({}, itemProps), genIcon_1.default(icon, {
            root: iconRoot,
            color: iconColor,
            description: description
        }, {
            content: badge,
            color: badgeColor
        })));
    };
    IconItem.defaultProps = {
        iconRoot: 'common',
        badgeColor: 'red'
    };
    return IconItem;
}(react_1.Component));
exports.default = IconItem;
